'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dofMask = require('../dof-mask');

var _dofMask2 = _interopRequireDefault(_dofMask);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import nativeService from '../common/services/nativeService';
// const dom = weex.requireModule('dom');
exports.default = {
  components: { DofMask: _dofMask2.default },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    delTitle: {
      type: String,
      default: '删除'
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {
    // var self = this;
    /* setTimeout(function(){
        self.checkDomHeight();
      },300);*/
  },

  methods: {
    onDelete: function onDelete() {
      this.$emit('onDelete', {});
    },
    layoutClick: function layoutClick() {
      this.$emit('close', {});
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-operation-modal/index.vue
// module id = 360
// module chunks = 0 1